import React from 'react';
import Decode from '../Decode/Decode'
import Ads from '../Ads/Ads'
import {NavItem, Nav, Navbar, Clearfix, Grid, Row, Well} from 'react-bootstrap';

export const App = (props) => (
  <Clearfix>

    <Navbar>
      <Navbar.Header>
        <Navbar.Brand>
          <code className="regexp">/{window.location.host}/</code>
        </Navbar.Brand>
      </Navbar.Header>
      <Nav>
        <NavItem eventKey={1} href={"http://www.string-io.com/"}>www.string-io.com</NavItem>
        <NavItem eventKey={2} href={"http://www.number-io.com/"}>www.number-io.com</NavItem>
        <NavItem eventKey={3} href={"http://www.time-io.com/"}>www.time-io.com</NavItem>
        <NavItem eventKey={4} href={"http://www.color-io.com/"}>www.color-io.com</NavItem>
        <NavItem eventKey={5} href={"http://www.prettyprint-io.com/"}>www.prettyprint-io.com</NavItem>
        <NavItem eventKey={6} href={"http://www.validate-io.com/"}>www.validate-io.com</NavItem>
      </Nav>
    </Navbar>

    <Grid>
      <Row>
        <Decode>
        </Decode>
        <Well className="top-buffer">
          <Ads></Ads>
        </Well>
      </Row>
    </Grid>
  </Clearfix>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js